import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import EventServiceForm from '@/components/EventServiceForm'

type Props = {
  service_types: string[]
  price_ranges: string[]
  statuses: string[]
  additional_service_options: string[]
}

export default function AdminEventServicesNew({ service_types, price_ranges, statuses, additional_service_options }: Props) {
  return (
    <>
      <Head title="Admin - New Event Service" />
      <EventServiceForm serviceTypes={service_types} priceRanges={price_ranges} statuses={statuses} additionalServiceOptions={additional_service_options} />
    </>
  )
}

AdminEventServicesNew.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
